import React from "react";
import "./index.css";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/landingPage";
import U1 from "./pages/u1";
import PmPage from "./pages/Pm";
import V5 from "./pages/v5";
import OrderConfirmation from "./pages/order-confirmation";
import NotFoundPage from "./pages/404/notfound";
import Privacy from "./pages/documentations/privacy";
import Terms from "./pages/documentations/terms";
import Contact from "./pages/documentations/contact";
import Disclaimer from "./pages/documentations/disclaimer";
import ReturnPage from "./pages/documentations/return";
import V12 from "./pages/v12";
import V2 from "./pages/v2";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/v2" element={<V2 />} />
        <Route path="/u1" element={<U1 />} />
        <Route path="/pm" element={<PmPage />} />
        <Route path="/v5" element={<V5 />} />
        <Route path="/v12" element={<V12 />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/returns" element={<ReturnPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
